import React, { useState } from 'react';
import TopicInput from '../components/TopicInput';
import QuizCard from '../components/QuizCard';
import { generateQuiz } from '../services/gemini';
import { saveQuizResult, auth } from '../services/firebase';

const Quiz = () => {
  const [topic, setTopic] = useState('');
  const [quiz, setQuiz] = useState(null);
  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [score, setScore] = useState(0);

  const handleTopicSubmit = async (topicText) => {
    setLoading(true);
    setTopic(topicText);
    setCompleted(false);

    try {
      const quizData = await generateQuiz(topicText);
      setQuiz(quizData);
      setLoading(false);
    } catch (error) {
      console.error('Error generating quiz:', error);
      setLoading(false);
    }
  };

  const handleQuizSubmit = async (answers, finalScore) => {
    try {
      const userId = auth.currentUser?.uid;
      if (userId) {
        await saveQuizResult(userId, {
          topic,
          score: finalScore,
          answers,
          totalQuestions: quiz.questions.length,
        });
      }

      setScore(finalScore);
      setCompleted(true);
    } catch (error) {
      console.error('Error saving quiz result:', error);
    }
  };

  const handleReset = () => {
    setTopic('');
    setQuiz(null);
    setCompleted(false);
    setScore(0);
  };

  return (
    <div className="container-custom py-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold mb-2">Quick Quiz</h1>
          <p className="text-slate-400">Test your knowledge on any topic</p>
        </div>

        {/* Input or Quiz */}
        {!quiz && !loading && (
          <TopicInput onSubmit={handleTopicSubmit} loading={loading} placeholder="Enter a topic to quiz yourself..." />
        )}

        {loading && (
          <div className="flex justify-center py-12">
            <div className="spinner"></div>
          </div>
        )}

        {quiz && !completed && (
          <div className="fade-in">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-semibold">Quiz: {topic}</h2>
              <button onClick={handleReset} className="btn-outline text-sm">
                New Quiz
              </button>
            </div>
            <QuizCard quiz={quiz} onSubmit={handleQuizSubmit} />
          </div>
        )}

        {completed && (
          <div className="fade-in space-y-6">
            <div className="card text-center">
              <div className="mb-4">
                {score >= 80 ? '🎉' : score >= 60 ? '👏' : '💪'}
              </div>
              <h2 className="text-3xl font-bold mb-2">Quiz Complete!</h2>
              <p className="text-5xl font-bold gradient-text my-6">{score}%</p>
              <p className="text-slate-400 mb-6">
                {score >= 80 ? 'Excellent work!' : score >= 60 ? 'Good effort! Keep practicing.' : 'Keep learning and try again!'}
              </p>
              <div className="flex gap-4 justify-center">
                <button onClick={handleReset} className="btn-primary">
                  Take Another Quiz
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Quiz;